export default "__VITE_ASSET__CJq9voG___"